import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import GoBack from 'components/wise-components/GoBack';
import NewContactForm from 'components/wise-components/NewContactForm';
import React, { useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { routePaths } from 'routes/routePaths';
import Select from 'react-select';

export const preferredLanguage = [
  { value: '1', label: 'Polish' },
  { value: '2', label: 'Portuguese' },
  { value: '3', label: 'Dutch' },
  { value: '4', label: 'Italian' },
  { value: '5', label: 'French' },
  { value: '6', label: 'Spanish' },
  { value: '7', label: 'English' },
  { value: '8', label: 'German' },
  { value: '9', label: 'Czech' },
  { value: '10', label: 'Hungarian' },
  { value: '11', label: 'Indonesian' },
  { value: '12', label: 'Japanese' },
  { value: '13', label: 'Russian' },
  { value: '14', label: 'Romanian' },
  { value: '15', label: 'Turkish' },
  { value: '16', label: 'Chinese' }
];

function ElseContactContact() {
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [knowBankAccount, setKnowBankAccount] = useState(true);
  const [value, setValue] = useState(null);

  const handleSubmit1 = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      navigate(routePaths.REVIEW_URL);
    }

    setValidated(true);
  };
  return (
    <>
      <GoBack text="Enter their account details" />

      <Form className="mt-3">
        <Form.Group controlId="fullName" className="mb-3">
          <Form.Label className="fw-normal mb-1">Their email</Form.Label>
          <Form.Control
            required
            type="email"
            placeholder="example@example.ex"
            className="py-2"
          />
          <Form.Control.Feedback type="invalid">
            <FontAwesomeIcon icon="exclamation-circle" /> Please fill out this
            field.
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group>
          <div className="px-3 py-2 border rounded-2">
            <Form.Check
              onChange={() => setKnowBankAccount(pre => !pre)}
              type="checkbox"
              id="checkedCheckbox"
              label="I know their bank details"
              className="mb-0 wise-checkbox"
              defaultChecked={knowBankAccount}
            />
          </div>
        </Form.Group>
      </Form>
      {knowBankAccount ? (
        <>
          <div className="mt-4">
            <p className="fw-bold fs-1 text-900">Recipient's bank details</p>
          </div>
          <NewContactForm />
        </>
      ) : (
        <div className="rightContent mt-4">
          <Alert variant="info">
            <Flex>
              <FontAwesomeIcon icon="exclamation-circle" size="3x" />
              <p className="ms-3 mb-0">
                Please enter their email address in the email field. We'll send
                an email to request their bank details once you've paid for your
                transfer. Make sure they respond to our email or the money will
                be refunded to you.
              </p>
            </Flex>
          </Alert>
          <Form noValidate validated={validated} onSubmit={handleSubmit1}>
            <Form.Group controlId="fullName" className="mb-3">
              <Form.Label className="fw-normal mb-1">
                Full name of the account holder
              </Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="First name"
                className="py-2"
              />
              <Form.Control.Feedback type="invalid">
                <FontAwesomeIcon icon="exclamation-circle" /> Name cannot be
                empty.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group>
              <Form.Label className="fw-normal mb-1">
                Recipient's preferred language
              </Form.Label>
              <Select
                closeMenuOnSelect={true}
                options={preferredLanguage}
                placeholder="Recipient's preferred language"
                classNamePrefix="react-select"
                value={value}
                onChange={value => setValue(value)}
                classNames={{
                  valueContainer: () => 'py-2'
                }}
              />
            </Form.Group>
            <Button
              variant="primary"
              className="w-100 mt-5 rounded-5 h-48px"
              type="submit"
            >
              Confirm
            </Button>
          </Form>
        </div>
      )}
    </>
  );
}

export default ElseContactContact;
